import { Content, ContentMetadata, SelectedMedia } from '@/lib/model';

export function isVideoType(
  media: SelectedMedia,
  content?: Content | ContentMetadata,
) {
  return (
    media?.media?.type?.toLowerCase() === 'video' ||
    content?.type?.toLowerCase() === 'video'
  );
}

export function isAudioType(
  media: SelectedMedia,
  content?: Content | ContentMetadata,
) {
  return (
    media?.media?.type?.toLowerCase() === 'audio' ||
    content?.type?.toLowerCase() === 'audio'
  );
}
